const confirmTemplate = require("./confirm_code.html.slim")
declare var angular

export class TwoFactorConfirm {
  static $inject = ['$rootScope', '$scope', 'users']

  code: string;
  phone: string;
  qrCode: string;
  form: any;

  error: string;
  errorMaxRetries: string;

  loading: string;

  constructor(
    public $rootScope,
    public $scope,
    private users
  ) {
    $scope.$on('confirmTwoFactor', ((event, data) => {
      this.error = ''
      this.errorMaxRetries = ''
      this.loading = ''
      this.form = data
      this.$scope.twoFactorConfirmDialog.show();
      this.requestCode();
    }));
  }

  confirmCode(code) {
    this.users.confirmTwoFactorAuth(code)
      .then(() => {
        this.code = null;
        this.$scope.twoFactorConfirmDialog.hide();
        this.$rootScope.$broadcast('confirmTwoFactorSuccess')
      })
      .catch((error) => {
        this.code = null;
        this.code = ''
        this.error = error.data.message;
      });
  }

  requestCode() {
    this.loading = "loading";
    this.users.requestTwoFactorAuth()
      .then(() => {
        this.loading = "loaded";
      })
      .catch((error) => {
        if (error.data.error_code && error.data.error_code === 'max_retries_reached') {
          this.errorMaxRetries = error.data.message;
          this.resetSendError();
        }else{
          this.error = error.data.message;
        }
      });
  }
  resetSendError() {
    this.loading = "";
    setTimeout(() => { 
      this.errorMaxRetries = '';
    }, 120000);
  }
}

angular.module('wbComponents').directive('twoFactorAuthConfirm', function() {
  return {
    restrict: 'E',
    templateUrl: confirmTemplate,
    controller: TwoFactorConfirm,
    controllerAs: 'confirm',
    bindToController: true
  }
})
